// extracted by mini-css-extract-plugin
export default {"cls1":"dm_OmxWRRFeHNbOPdPWM","cls2":"Gif89UcRZ4UjfLh1YyPf dm_OmxWRRFeHNbOPdPWM"};